<template>
    <div class="row pt-8 pb-12" v-if="page && page.total">
        <div class="col">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item ml-auto">
                        <button class="page-link text-muted" v-on:click="goToPage(page.current_page - 1)">
                            Prev
                        </button>
                    </li>
                    <li
                        class="page-item"
                        :class="{ 'active': page_number == page.current_page }"
                        v-for="page_number in pages"
                        :key="`page-${page_number}`"
                    >
                        <button class="page-link" v-on:click="goToPage(page_number)" v-html="page_number" />
                    </li>
                    <li class="page-item mr-auto">
                        <a class="page-link text-muted" v-on:click="goToPage(page.current_page + 1)">
                            Next
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['page'],

        computed: {
            pages() {
                return this.page ? this.pagination(this.page.current_page, this.page.last_page) : [];
            }
        },
        watch: {
            'page.current_page'() {
                const query = this.$route.query;
                this.$router.replace({ query: { ...query, page: this.page.current_page } }).catch(() => {});
            }
        },
        methods: {
            pagination(currentPage, pageCount) {
                let delta = 2,
                    left = currentPage - delta,
                    right = currentPage + delta + 1,
                    result = [];

                result = Array.from({ length: pageCount }, (v, k) => k + 1).filter((i) => i && i >= left && i < right);

                if (result.length > 1) {
                    if (result[0] > 1) {
                        if (result[0] > 2) {
                            result.unshift('...');
                        }
                        result.unshift(1);
                    }

                    if (result[result.length - 1] < pageCount) {
                        if (result[result.length - 1] !== pageCount - 1) {
                            result.push('...');
                        }
                        result.push(pageCount);
                    }
                }

                return result;
            },
            goToPage(page) {
                if (page > 0 && page <= this.page.last_page && page != '...' && page != this.page.current_page) {
                    this.$emit('retrieve-page', page);
                }
            }
        }
    };
</script>
